import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import { FormWrapper } from "../../../../components/CustomForm/FormStyles";
import Text from "../../../../components/Common/Text";
import useEmpresa from "../../../../hooks/useEmpresa";
import { formatCedula } from "../../../../utils/StringUtil";
import PropTypes from "prop-types";

const PrecertificacionDatosAfiliado = (props) => {
  const { afiliado } = props;
  const empresa = useEmpresa();
  return (
    <Section>
      <FormWrapper maxWidth={"850px"} borderColor={empresa?.COLOR_PRINCIPAL}>
        <Text
          color={empresa?.COLOR_PRINCIPAL}
          weight={"bold"}
          size={"20px"}
          margin="0 0 10px 0"
        >
          {afiliado?.nombre}
        </Text>
        <Text margin="0 0 10px 0">{afiliado?.plan}</Text>
        <Text margin="0 0 10px 0">{afiliado?.numeroPlastico}</Text>
        <Text margin="0 0 10px 0">{formatCedula(afiliado?.cedula)}</Text>
      </FormWrapper>
    </Section>
  );
};

PrecertificacionDatosAfiliado.propTypes = {
  afiliado: PropTypes.shape({
    nombre: PropTypes.string,
    plan: PropTypes.string,
    numeroPlastico: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cedula: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

export default PrecertificacionDatosAfiliado;
